import { render, staticRenderFns } from "./Pa.vue?vue&type=template&id=66478970&scoped=true"
import script from "./Pa.vue?vue&type=script&lang=js"
export * from "./Pa.vue?vue&type=script&lang=js"
import style0 from "./Pa.vue?vue&type=style&index=0&id=66478970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66478970",
  null
  
)

export default component.exports